import React from "react";
import { Card, Skeleton, Typography } from "antd";
import { StarFilled } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import "./ModuleCardItem.less";
import Cupoints from "./../../Components/Cupoints";
import VideoThumbnailCard from "../VideoThumbnailCard/VideoThumbnailCard";

const { Text, Title } = Typography;

const ModuleCardItem = ({ module, actionMenu, index = 0, searchTerm = "" }) => {
    const videos = Array.isArray(module?.videos) ? module.videos : [];
    const visibleVideos = videos.slice(0, 3);
    const hiddenVideoCount = Math.max(videos.length - 3, 0);
    const primaryAuthorName = module?.primaryAuthor
        ? `${module.primaryAuthor.firstName} ${module.primaryAuthor.lastName}`
        : "Unknown author";
    const coAuthorNames = (module?.coAuthors || [])
        .map((coAuthor) => `${coAuthor.firstName} ${coAuthor.lastName}`)
        .join(", ");

    return (
        <Card
            className="module-card-item"
            hoverable
            bordered={true}
            style={{ animationDelay: `${60 * index}ms` }}>
            <div className="module-card-item__layout">
                <div className="module-card-item__preview">
                    <div className="module-card-item__open-icon">
                        <StarFilled />
                    </div>
                </div>

                <div className="module-card-item__meta">
                    <Title level={5} style={{ margin: 0 }}>
                        <Highlighter
                            searchWords={searchTerm ? [searchTerm] : []}
                            autoEscape
                            textToHighlight={module?.name || ""}
                        />
                    </Title>
                    <Text type="secondary">{primaryAuthorName}</Text>
                    {coAuthorNames ? (
                        <Text type="secondary">Co-authors: {coAuthorNames}</Text>
                    ) : null}
                    <Text type="secondary">{videos.length} videos</Text>
                    <Text>
                        <Cupoints points={module?.price ?? module?.valuePrice ?? 0}></Cupoints>
                    </Text>
                </div>

                <div className={`module-card-item__right ${!actionMenu ? "module-card-item__right--centered" : ""}`}>
                    {actionMenu ? (
                        <div
                            className="module-card-item__actions"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                            }}>
                            {actionMenu}
                        </div>
                    ) : null}
                    <div className="module-card-item__thumbnails">
                        {visibleVideos.map((video) => (
                            <VideoThumbnailCard
                                key={video.id}
                                className="module-card-item__thumb"
                                video={video}
                            />
                        ))}
                        {hiddenVideoCount > 0 ? (
                            <div className="module-card-item__more-videos">
                                +{hiddenVideoCount} more
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </Card>
    );
};

export const ModuleCardItemSkeleton = ({ index = 0 }) => {
    return (
        <Card
            className="module-card-item module-card-item--skeleton"
            bordered={true}
            style={{ animationDelay: `${60 * index}ms` }}>
            <div className="module-card-item__layout">
                <div className="module-card-item__preview">
                    <Skeleton.Avatar active size="default" />
                </div>

                <div className="module-card-item__meta">
                    <Skeleton active title={{ width: "45%" }} paragraph={{ rows: 3 }} />
                </div>

                <div className="module-card-item__right module-card-item__right--centered">
                    <div className="module-card-item__thumbnails">
                        <div className="module-card-item__thumb module-card-item__thumb--skeleton">
                            <Skeleton.Input active fullSize />
                        </div>
                        <div className="module-card-item__thumb module-card-item__thumb--skeleton">
                            <Skeleton.Input active fullSize />
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default ModuleCardItem;
